import {PageLink} from '../../_metronic/layout/core'
import {useParams} from 'react-router-dom'
import {Navigation} from '../../components/Navigation'
import useMeta from '../../hook/useMeta'
import BadgeProducts from './layouts/BadgeProducts'
import BadgeDetails from './layouts/BadgeDetails'

const breadcrumbs: PageLink[] = [
  {
    title: 'Products',
    path: '/products/all-products/all',
    isSeparator: false,
    isActive: false,
  },
  {
    title: 'Product Badges',
    path: '/products/product-badges',
    isSeparator: false,
    isActive: false,
  },
]

const ProductBadgeDetailsPage = () => {
  const {id, name} = useParams<{id?: string; name?: string}>()
  const isEdit = Boolean(id)

  useMeta(isEdit ? `${name}` : 'Create Product Badge')
  const navigationData = [
    {
      key: 'details',
      label: 'Details',
      component: <BadgeDetails isEdit={isEdit} />,
    },
  ]

  // Only add products tab if editing
  if (isEdit) {
    navigationData.push({
      key: 'products',
      label: 'Products',
      component: <BadgeProducts badgeId={id!} />,
    })
  }

  return (
    <Navigation
      baseUrl={`/products/product-badges${isEdit ? `/${id}/${name}` : '/new'}`}
      breadcrumbs={breadcrumbs}
      navigationData={navigationData}
      pageTitle={isEdit ? `${name}` : 'Create Product Badge'}
    />
  )
}

export default ProductBadgeDetailsPage
